import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { StackOutput } from "types/generated";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import TableCellText from "ds/components/Table/Row/CellText";

type OutputWithStack = StackOutput & {
  stackId: string;
  stackName: string;
};

const TemplateDeploymentOutputsNameCell = ({
  item: output,
  ...cellProps
}: TableSimpleCellProps<OutputWithStack>) => {
  return (
    <TableSimpleCell {...cellProps}>
      <TableCellText>{output.id}</TableCellText>
    </TableSimpleCell>
  );
};

export default TemplateDeploymentOutputsNameCell;
